import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '../../../../common/element/Dialog'
import Tabs from '../../../../common/element/Tabs/Tabs'
import TabList from '../../../../common/element/Tabs/TabList'
import TabNav from '../../../../common/element/Tabs/TabNav'
import TabContent from '../../../../common/element/Tabs/TabContent'
import BtnPrimary from '../../../../common/element/Buttons/btnPrimary'
import Select from '../../../../common/element/Select'
import ThreeDotLoader from "../../../../common/element/ButtonLoader/ThreeDotLoader"
import CommonPhoneInput from '../../../../common/CommonPhoneInput/CommonPhoneInput'
import SweetAlertService from '../../../../common/SweetAlert/SweetAlert';

import { clearCities, clearStates, getCityList, getCountryList, getStateList } from '../../../../redux/countryStateCity/cityStateCountrySlice'
import { selectCityList, selectCountryList, selectStateList } from '../../../../redux/countryStateCity/cityStateCountrySelector'
import { getSessionMasterList } from '../../../../redux/SessionMaster/sessionMasterSlice'
import { selectSessionMasterList } from '../../../../redux/SessionMaster/sessionMasterSelector'
import {
    createScienceOfSelf,
    updateScienceOfSelf,
    clearCreateScienceOfSelf,
    clearUpdateScienceOfSelf
} from '../../../../redux/ScienceOfSelf/Scienceofselfslice'
import {
    selectCreateScienceOfSelfData,
    selectCreateScienceOfSelfLoading,
    selectCreateScienceOfSelfError,
    selectUpdateScienceOfSelfData,
    selectUpdateScienceOfSelfLoading,
    selectUpdateScienceOfSelfError
} from '../../../../redux/ScienceOfSelf/Scienceofselfselectors'

const AddEditIndividual = ({ dialogOpen, onDialogClose, individualData, isEdit }) => {
    const [tab, setTab] = useState("tab1");
    const countryList = useSelector(selectCountryList);
    const stateList = useSelector(selectStateList);
    const cityList = useSelector(selectCityList);
    const dispatch = useDispatch();
    const selectSessionMasterListData = useSelector(selectSessionMasterList);

    // Science of Self Redux Selectors
    const createData = useSelector(selectCreateScienceOfSelfData);
    const createLoading = useSelector(selectCreateScienceOfSelfLoading);
    const createError = useSelector(selectCreateScienceOfSelfError);

    const updateData = useSelector(selectUpdateScienceOfSelfData);
    const updateLoading = useSelector(selectUpdateScienceOfSelfLoading);
    const updateError = useSelector(selectUpdateScienceOfSelfError);

    console.log(selectSessionMasterListData, "selectSessionMasterListDataselectSessionMasterListData")

    // Convert API data to Select options format
    const countryOptions = countryList.map(country => ({
        value: country.country_id.toString(),
        label: country.country_name
    }));

    // Initial form state
    const initialFormData = {
        // Personal Information (Tab 1)
        firstName: "",
        lastName: "",
        companyName: "",
        emailAddress: "",
        phoneNumber: "",
        gender: null,

        // Address Details (Tab 2)
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        pincode: "",
        phoneLandline: "",

        // Other Details (Tab 3)
        enablePortal: true,
        assignCoach: null,
        sessionName: null,
        date: "",
        time: "",
        notes: ""
    };

    const [formData, setFormData] = useState(initialFormData);

    const initialFormErrors = {
        firstName: "",
        lastName: "",
        companyName: "",
        emailAddress: "",
        phoneNumber: "",
        gender: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pincode: "",
        phoneLandline: "",
        enablePortal: "",
        assignCoach: "",
        sessionName: "",
        date: "",
        time: "",
        notes: ""
    };

    const [formError, setFormErrors] = useState(initialFormErrors);

    const findOptionByValue = (options, value) => {
        return options.find(option => option.value === value) || null;
    };

    const genderOptions = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" }
    ];

    const sessionOptions = useMemo(() => selectSessionMasterListData?.map(session => ({
        value: session.id || session.session_id,
        label: session.name || session.session_name || session.title
    })) || [], [selectSessionMasterListData]);

    const stateOptions = stateList.map(state => ({
        value: state.state_id.toString(),
        label: state.state_name
    }));

    const cityOptions = cityList.map(city => ({
        value: city.city_id.toString(),
        label: city.city_name
    }));

    // Today's date in YYYY-MM-DD format for min date restriction
    const todayDate = new Date().toISOString().split('T')[0];

    useEffect(() => {
        if (isEdit && individualData) {
            let addrLine1 = "";
            let addrLine2 = "";

            if (individualData.address) {
                const parts = individualData.address.split('\n');
                addrLine1 = parts[0] || "";
                addrLine2 = parts.slice(1).join('\n') || "";
            } else {
                addrLine1 = individualData.addressLine1 || "";
                addrLine2 = individualData.addressLine2 || "";
            }

            setFormData({
                firstName: individualData.user?.first_name || individualData.firstName || "",
                lastName: individualData.user?.last_name || individualData.lastName || "",
                companyName: individualData.company_name || individualData.companyName || "",
                emailAddress: individualData.user?.email || individualData.emailAddress || "",
                phoneNumber: individualData.user?.mobile_number || individualData.phoneNumber || "",
                gender: individualData.gender ? findOptionByValue(genderOptions, individualData.gender.toLowerCase()) : null,
                addressLine1: addrLine1,
                addressLine2: addrLine2,
                city: individualData.city?.city_id || individualData.city_id || individualData.city || "",
                state: individualData.state?.state_id || individualData.state_id || individualData.state || "",
                country: individualData.country?.country_id || individualData.country_id || individualData.country || "",
                pincode: individualData.pincode || "",
                phoneLandline: individualData.phone_landline || individualData.phoneLandline || "",
                enablePortal: individualData.isPortalEnabled ?? individualData.enablePortal ?? false,
                sessionName: (individualData.sessions && individualData.sessions.length > 0)
                    ? findOptionByValue(sessionOptions, individualData.sessions[0].session?.session_id)
                    : (individualData.sessionName || individualData.session_id ? findOptionByValue(sessionOptions, individualData.sessionName || individualData.session_id) : null),
                date: (individualData.sessions && individualData.sessions.length > 0) ? individualData.sessions[0].session_date : (individualData.date || individualData.session_date || ""),
                time: (individualData.sessions && individualData.sessions.length > 0) ? individualData.sessions[0].session_time : (individualData.time || individualData.session_time || ""),
                notes: individualData.notes || ""
            });

            // Load states and cities if country/state are already selected
            const countryId = individualData.country?.country_id || individualData.country_id || individualData.country;
            if (countryId) {
                dispatch(getStateList(countryId));
            }
            const stateId = individualData.state?.state_id || individualData.state_id || individualData.state;
            if (stateId) {
                dispatch(getCityList(stateId));
            }
        } else {
            setFormData(initialFormData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEdit, individualData, dialogOpen, sessionOptions]);

    // Handle Create Success
    useEffect(() => {
        if (createData) {
            console.log('Science of Self created successfully:', createData);
            SweetAlertService.showSuccess({ message: 'Individual added successfully!' });

            // Clear the state
            dispatch(clearCreateScienceOfSelf());

            // Close dialog and refresh parent list
            handleDialogClose();

            // If you have a refresh callback from parent, call it here
            // onRefresh();
        }
    }, [createData, dispatch]);

    // Handle Create Error
    useEffect(() => {
        if (createError) {
            console.error('Create error:', createError);
            SweetAlertService.showError({ message: createError, icon: 'error' });
        }
    }, [createError]);

    // Handle Update Success
    useEffect(() => {
        if (updateData) {
            console.log('Science of Self updated successfully:', updateData);
            // Show success message
            SweetAlertService.showSuccess({ message: 'Individual updated successfully!' });

            // Clear the state
            dispatch(clearUpdateScienceOfSelf());

            // Close dialog and refresh parent list
            handleDialogClose();

            // If you have a refresh callback from parent, call it here
            // onRefresh();
        }
    }, [updateData, dispatch]);

    // Handle Update Error
    useEffect(() => {
        if (updateError) {
            console.error('Update error:', updateError);
            SweetAlertService.showError({ message: updateError, icon: 'error' });
        }
    }, [updateError]);

    const handlePhoneKeyPress = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
        }
    };

    // Handle country change - fetch states when country is selected
    const handleCountryChange = (value) => {
        handleInputChange("country", value);

        handleInputChange("state", 0);
        handleInputChange("city", 0);
        dispatch(clearCities());

        if (value) {
            dispatch(getStateList(value));
        } else {
            dispatch(clearStates());
        }
    };

    // Handle state change - fetch cities when state is selected
    const handleStateChange = (value) => {
        handleInputChange("state", value);

        // Reset city when state changes
        handleInputChange("city", 0);

        // Fetch cities for selected state
        if (value) {
            dispatch(getCityList(value));
        } else {
            dispatch(clearCities());
        }
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        if (formError[field]) {
            setFormErrors(prev => ({
                ...prev,
                [field]: ""
            }));
        }
    };

    // Specific handler for Phone Inputs to validate length against country code
    const handlePhoneChange = (field, value, country) => {
        handleInputChange(field, value);

        // Validation logic:
        if (value && country && country.format) {
            const requiredLength = (country.format.match(/\./g) || []).length;

            if (value.length < requiredLength) {
                setFormErrors(prev => ({
                    ...prev,
                    [field]: "Invalid phone number"
                }));
            } else {
                setFormErrors(prev => ({
                    ...prev,
                    [field]: ""
                }));
            }
        } else {
            setFormErrors(prev => ({
                ...prev,
                [field]: ""
            }));
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateTab1 = () => {
        const errors = {};
        if (!formData.firstName) errors.firstName = "First name is required";
        if (!formData.lastName) errors.lastName = "Last name is required";
        if (!formData.emailAddress) {
            errors.emailAddress = "Email address is required";
        } else if (!validateEmail(formData.emailAddress)) {
            errors.emailAddress = "Please enter a valid email address";
        }

        if (!formData.phoneNumber) {
            errors.phoneNumber = "Phone number is required";
        } else if (formError.phoneNumber) {
            errors.phoneNumber = formError.phoneNumber;
        }

        if (!formData.gender) errors.gender = "Gender is required";

        setFormErrors(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    };

    const validateTab2 = () => {
        const errors = {};
        // Removed validation for addressLine1 as per requirement
        // if (!formData.addressLine1) errors.addressLine1 = "Address line 1 is required";

        if (formError.phoneLandline) {
            errors.phoneLandline = formError.phoneLandline;
        }

        setFormErrors(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    };

    const validateTab3 = () => {
        const errors = {};
        if (!formData.sessionName) errors.sessionName = "Session Name is required";
        if (!formData.date) errors.date = "Date is required";

        setFormErrors(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    };

    const handleNext = () => {
        if (tab === "tab1" && validateTab1()) {
            setTab("tab2");
        } else if (tab === "tab2" && validateTab2()) {
            setTab("tab3");
        }
    };

    const handleTabClick = (targetTab) => {
        if (tab === "tab1" && !validateTab1()) {
            return;
        } else if (tab === "tab2" && !validateTab2()) {
            return;
        }
        setTab(targetTab);
    };

    const handleSubmit = () => {
        if (!validateTab3()) {
            return;
        }

        // Prepare API payload according to the API schema
        const apiPayload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.emailAddress,
            phone_number: formData.phoneNumber,
            gender: formData.gender?.value || formData.gender,
            company_name: formData.companyName,
            isPortalEnabled: formData.enablePortal,
            country_id: parseInt(formData.country) || 0,
            state_id: parseInt(formData.state) || 0,
            city_id: parseInt(formData.city) || 0,
            address: `${formData.addressLine1}${formData.addressLine2 ? '\n' + formData.addressLine2 : ''}`,
            pincode: formData.pincode,
            phone_landline: formData.phoneLandline,
            session_id: formData.sessionName?.value || 0,
            session_date: formData.date,
            notes: formData.notes
        };

        console.log("Submitting form data:", apiPayload);

        if (isEdit && individualData?.id) {
            // Update existing record
            dispatch(updateScienceOfSelf({
                science_id: individualData.id,
                scienceData: apiPayload
            }));
        } else {
            // Create new record
            dispatch(createScienceOfSelf(apiPayload));
        }
    };

    const handleDialogClose = () => {
        setFormData(initialFormData);
        setFormErrors(initialFormErrors);
        setTab("tab1");
        dispatch(clearCreateScienceOfSelf());
        dispatch(clearUpdateScienceOfSelf());
        onDialogClose();
    };

    useEffect(() => {
        const payload = {
            page: 0,
            limit: 0,
            archived: false,
            access_group_id: 4
        };
        dispatch(getCountryList());
        dispatch(getSessionMasterList(payload));
    }, [dispatch]);

    // Determine if button should be disabled
    const isSubmitting = createLoading || updateLoading;

    return (
        <Dialog
            isOpen={dialogOpen}
            onClose={handleDialogClose}
            width={900}
            onRequestClose={handleDialogClose}
            bodyOpenClassName="overflow-hidden"
        >
            <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center justify-between">
                <div className="flex items-center">
                    <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.1299 5.68066C11.9004 5.64239 11.6649 5.70682 11.4873 5.85742C11.3096 6.0079 11.207 6.22899 11.207 6.46191V20.3076C11.207 20.7448 11.5626 21.0996 12 21.0996C12.4373 21.0993 12.792 20.7446 12.792 20.3076V7.39648L19.5156 8.5166V19.5156H14.7686C14.3313 19.5158 13.9766 19.8705 13.9766 20.3076C13.9766 20.7447 14.3313 21.0994 14.7686 21.0996H20.3076C20.7454 21.0996 21.0996 20.7452 21.0996 20.3076V7.84668C21.0996 7.45949 20.8196 7.12825 20.4375 7.06445L12.1299 5.68066Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M14.7686 16.0542C14.3309 16.0543 13.9766 16.4085 13.9766 16.8462V20.3071C13.9766 20.7448 14.3309 21.1 14.7686 21.1001H17.5381C17.9759 21.1001 18.3301 20.7448 18.3301 20.3071V16.8462C18.3301 16.4085 17.9759 16.0542 17.5381 16.0542H14.7686ZM16.7461 19.5151H15.5615V17.6382H16.7461V19.5151Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M6.45996 16.0542C6.02238 16.0543 5.66797 16.4085 5.66797 16.8462V20.3071C5.66797 20.7447 6.02236 21.1 6.45996 21.1001H9.22949C9.66723 21.1001 10.0215 20.7448 10.0215 20.3071V16.8462C10.0215 16.4085 9.66721 16.0542 9.22949 16.0542H6.45996ZM8.4375 19.5151H7.25293V17.6382H8.4375V19.5151Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M3.82324 2.91113C3.59387 2.87315 3.35837 2.93695 3.18066 3.08789C3.0032 3.23841 2.90039 3.45947 2.90039 3.69238V20.3076C2.90053 20.7446 3.25593 21.0996 3.69336 21.0996C4.13057 21.0995 4.48521 20.7445 4.48535 20.3076V4.62695L11.209 5.74707V19.5146H6.46191C6.02467 19.5148 5.66992 19.8707 5.66992 20.3076C5.6701 20.7444 6.02478 21.0994 6.46191 21.0996H12.001C12.4387 21.0996 12.7928 20.745 12.793 20.3076V5.07715C12.793 4.68974 12.5129 4.35957 12.1309 4.2959L3.82324 2.91113Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M17.1914 12.5928C16.9455 12.593 16.7463 12.7921 16.7461 13.0381V13.7305C16.7461 13.9765 16.9453 14.1765 17.1914 14.1768H17.8838C18.1302 14.1768 18.3301 13.9767 18.3301 13.7305V13.0381C18.3298 12.7919 18.13 12.5928 17.8838 12.5928H17.1914Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M14.4248 12.5928C14.1786 12.5928 13.9788 12.792 13.9785 13.0381V13.7305C13.9785 13.9767 14.1784 14.1768 14.4248 14.1768H15.1162C15.3626 14.1768 15.5625 13.9767 15.5625 13.7305V13.0381C15.5622 12.7919 15.3624 12.5928 15.1162 12.5928H14.4248Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M14.4248 9.82324C14.1786 9.82324 13.9788 10.0226 13.9785 10.2686V10.9609C13.9785 11.2072 14.1784 11.4072 14.4248 11.4072H15.1162C15.3626 11.4072 15.5625 11.2072 15.5625 10.9609V10.2686C15.5622 10.0225 15.3624 9.82324 15.1162 9.82324H14.4248Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M17.1914 9.82324C16.9455 9.82351 16.7463 10.0227 16.7461 10.2686V10.9609C16.7461 11.207 16.9454 11.407 17.1914 11.4072H17.8838C18.1302 11.4072 18.3301 11.2072 18.3301 10.9609V10.2686C18.3298 10.0225 18.13 9.82324 17.8838 9.82324H17.1914Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M8.88379 12.5928C8.63758 12.5928 8.43776 12.792 8.4375 13.0381V13.7305C8.4375 13.9767 8.63742 14.1768 8.88379 14.1768H9.57617C9.82229 14.1766 10.0215 13.9765 10.0215 13.7305V13.0381C10.0212 12.7921 9.8221 12.593 9.57617 12.5928H8.88379Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M6.11328 12.5928C5.8673 12.593 5.66822 12.7921 5.66797 13.0381V13.7305C5.66797 13.9765 5.86713 14.1765 6.11328 14.1768H6.80566C7.05192 14.1768 7.25195 13.9767 7.25195 13.7305V13.0381C7.2517 12.7919 7.05172 12.5928 6.80566 12.5928H6.11328Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M6.11328 9.82324C5.86727 9.8235 5.66822 10.0227 5.66797 10.2686V10.9609C5.66797 11.207 5.86713 11.407 6.11328 11.4072H6.80566C7.05192 11.4072 7.25195 11.2072 7.25195 10.9609V10.2686C7.2517 10.0225 7.05174 9.82324 6.80566 9.82324H6.11328Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M8.88379 9.82324C8.63756 9.82324 8.43776 10.0226 8.4375 10.2686V10.9609C8.4375 11.2072 8.63742 11.4072 8.88379 11.4072H9.57617C9.82229 11.407 10.0215 11.207 10.0215 10.9609V10.2686C10.0212 10.0227 9.82212 9.82345 9.57617 9.82324H8.88379Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M8.88379 7.05371C8.63756 7.05371 8.43776 7.25303 8.4375 7.49902V8.19141C8.4375 8.43777 8.63744 8.6377 8.88379 8.6377H9.57617C9.82227 8.63749 10.0215 8.43761 10.0215 8.19141V7.49902C10.0212 7.25316 9.82212 7.05392 9.57617 7.05371H8.88379Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                            <path d="M6.11328 7.05371C5.86727 7.05397 5.66822 7.25319 5.66797 7.49902V8.19141C5.66797 8.43761 5.86715 8.63743 6.11328 8.6377H6.80566C7.05189 8.6377 7.25195 8.43778 7.25195 8.19141V7.49902C7.2517 7.25299 7.05174 7.05371 6.80566 7.05371H6.11328Z" fill="#344054" stroke="white" strokeWidth="0.2" />
                        </svg>

                    </span>
                    <div>
                        <h5 className="mb-0 font-lato not-italic font-medium text-[16px] leading-[150%] text-[#101828]">
                            {isEdit ? 'Edit Individual' : 'Add Individual'}
                        </h5>
                    </div>
                </div>

                <button
                    onClick={handleDialogClose}
                    className="text-gray-400 hover:text-gray-600"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>

            <Tabs value={tab} variant="pill">
                <div className="px-6 mb-5">
                    <div className="p-1 rounded-lg client-portal-tab" style={{ backgroundColor: '#FFF4E5' }}>
                        <TabList>
                            <TabNav
                                value="tab1"
                                onClick={() => handleTabClick("tab1")}
                                style={{
                                    backgroundColor: tab === 'tab1' ? '#ffffff' : 'transparent',
                                    color: '#344054',
                                    fontWeight: tab === 'tab1' ? '600' : '500'
                                }}
                            >
                                Personal Information
                            </TabNav>
                            <TabNav
                                value="tab2"
                                onClick={() => handleTabClick("tab2")}
                                style={{
                                    backgroundColor: tab === 'tab2' ? '#ffffff' : 'transparent',
                                    color: '#344054',
                                    fontWeight: tab === 'tab2' ? '600' : '500'
                                }}
                            >
                                Address Details
                            </TabNav>
                            <TabNav
                                value="tab3"
                                onClick={() => handleTabClick("tab3")}
                                style={{
                                    backgroundColor: tab === 'tab3' ? '#ffffff' : 'transparent',
                                    color: '#344054',
                                    fontWeight: tab === 'tab3' ? '600' : '500'
                                }}
                            >
                                Other Details
                            </TabNav>
                        </TabList>
                    </div>
                </div>

                {/* Tab 1: Personal Information */}
                <TabContent value="tab1">
                    <div className="px-6">
                        {/* Name */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Name*
                            </label>
                            <div className="w-3/4 pl-2 flex gap-3">
                                <div className="flex-1">
                                    <input
                                        className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        value={formData.firstName}
                                        placeholder="Enter First name here"
                                        onChange={(e) => handleInputChange("firstName", e.target.value)}
                                    />
                                    {formError.firstName && (
                                        <p className="text-xs text-red-600 mb-2 mt-1">
                                            {formError.firstName}
                                        </p>
                                    )}
                                </div>
                                <div className="flex-1">
                                    <input
                                        className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        value={formData.lastName}
                                        placeholder="Enter Last name here"
                                        onChange={(e) => handleInputChange("lastName", e.target.value)}
                                    />
                                    {formError.lastName && (
                                        <p className="text-xs text-red-600 mb-2 mt-1">
                                            {formError.lastName}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Company Name */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Company Name
                            </label>
                            <div className="w-3/4 pl-2">
                                <input
                                    className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    value={formData.companyName}
                                    placeholder="Enter Company Name here"
                                    onChange={(e) => handleInputChange("companyName", e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Email*
                            </label>
                            <div className="w-3/4 pl-2">
                                <input
                                    type="email"
                                    className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    value={formData.emailAddress}
                                    placeholder="Enter Email address here"
                                    onChange={(e) => handleInputChange("emailAddress", e.target.value)}
                                />
                                {formError.emailAddress && (
                                    <p className="text-xs text-red-600 mb-2 mt-1">
                                        {formError.emailAddress}
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* Phone Number */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Phone Number*
                            </label>
                            <div className="w-3/4 pl-2">
                                <CommonPhoneInput
                                    value={formData.phoneNumber}
                                    onChange={(phone, country) => handlePhoneChange("phoneNumber", phone, country)}
                                    placeholder="Enter Phone Number here"
                                    error={formError.phoneNumber}
                                />
                            </div>
                        </div>

                        {/* Gender */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Gender*
                            </label>
                            <div className="w-3/4 pl-2">
                                <Select
                                    className="w-full h-9 select-options"
                                    placeholder="Select Gender"
                                    options={genderOptions}
                                    value={formData.gender}
                                    onChange={(selectedOption) => handleInputChange("gender", selectedOption)}
                                />
                                {formError.gender && (
                                    <p className="text-xs text-red-600 mb-2 mt-1">
                                        {formError.gender}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </TabContent>

                {/* Tab 2: Address Details */}
                <TabContent value="tab2">
                    <div className="px-6">
                        {/* Row 1: Country, State & City */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Country/State/City
                            </label>
                            <div className="w-3/4 pl-2 flex gap-3">
                                <div className="flex-1">
                                    <Select
                                        className="w-full h-9 select-options"
                                        placeholder="Select Country"
                                        options={countryOptions}
                                        value={countryOptions.find(c => c.value === formData.country.toString()) || null}
                                        onChange={(selectedOption) => handleCountryChange(selectedOption?.value || 0)}
                                    />
                                </div>
                                <div className="flex-1">
                                    <Select
                                        className={`w-full h-9 select-options ${(!formData.country || stateOptions.length === 0) ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        placeholder="State"
                                        options={stateOptions}
                                        value={stateOptions.find(s => s.value === formData.state.toString()) || null}
                                        onChange={(selectedOption) => handleStateChange(selectedOption?.value || 0)}
                                        isDisabled={!formData.country || stateOptions.length === 0}
                                    />
                                </div>
                                <div className="flex-1">
                                    <Select
                                        className={`w-full h-9 select-options ${(!formData.state || cityOptions.length === 0) ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        placeholder="City"
                                        options={cityOptions}
                                        value={cityOptions.find(c => c.value === formData.city.toString()) || null}
                                        onChange={(selectedOption) => handleInputChange("city", selectedOption?.value || 0)}
                                        isDisabled={!formData.state || cityOptions.length === 0}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Row 2: Address */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Address
                            </label>
                            <div className="w-3/4 pl-2">
                                <input
                                    className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-3"
                                    value={formData.addressLine1}
                                    placeholder="Line 1"
                                    onChange={(e) => handleInputChange("addressLine1", e.target.value)}
                                />
                                {formError.addressLine1 && (
                                    <p className="text-xs text-red-600 mb-2 mt-1">
                                        {formError.addressLine1}
                                    </p>
                                )}
                                <input
                                    className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    value={formData.addressLine2}
                                    placeholder="Line 2"
                                    onChange={(e) => handleInputChange("addressLine2", e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Row 3: Pincode & Landline */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Pincode/Landline
                            </label>
                            <div className="w-3/4 pl-2 flex gap-3">
                                <div className="flex-1">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        value={formData.pincode}
                                        placeholder="Pincode"
                                        onChange={(e) => handleInputChange("pincode", e.target.value)}
                                        onKeyPress={handlePhoneKeyPress}
                                    />
                                </div>
                                <div className="flex-1">
                                    <CommonPhoneInput
                                        value={formData.phoneLandline}
                                        onChange={(phone, country) => handlePhoneChange("phoneLandline", phone, country)}
                                        placeholder="Phone Landline"
                                        error={formError.phoneLandline}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </TabContent>

                {/* Tab 3: Other Details */}
                <TabContent value="tab3">
                    <div className="px-6">
                        {/* Enable Portal */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Enable Portal*
                            </label>
                            <div className="w-3/4 pl-2">
                                <div className="inline-flex rounded-lg border border-gray-300 bg-white overflow-hidden">
                                    <button
                                        type="button"
                                        onClick={() => handleInputChange("enablePortal", true)}
                                        className={`px-8 h-9 text-sm font-medium transition-colors ${formData.enablePortal
                                            ? 'text-gray-900'
                                            : 'bg-white text-gray-700 hover:bg-gray-50'
                                            }`}
                                        style={{
                                            backgroundColor: formData.enablePortal ? '#FFF4E5' : 'white'
                                        }}
                                    >
                                        Yes
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => handleInputChange("enablePortal", false)}
                                        className={`px-8 h-9 text-sm font-medium border-l border-gray-300 transition-colors ${!formData.enablePortal
                                            ? 'text-gray-900'
                                            : 'bg-white text-gray-700 hover:bg-gray-50'
                                            }`}
                                        style={{
                                            backgroundColor: !formData.enablePortal ? '#FFF4E5' : 'white'
                                        }}
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Session Name */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Session Name*
                            </label>
                            <div className="w-3/4 pl-2">
                                <Select
                                    className="w-full h-9 select-options"
                                    placeholder="Session Name"
                                    options={sessionOptions}
                                    value={formData.sessionName}
                                    onChange={(selectedOption) => handleInputChange("sessionName", selectedOption)}
                                />
                                {formError.sessionName && (
                                    <p className="text-xs text-red-600 mb-2 mt-1">
                                        {formError.sessionName}
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* Date */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Date*
                            </label>
                            <div className="w-3/4 pl-2">
                                <input
                                    type="date"
                                    className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer"
                                    value={formData.date}
                                    min={todayDate}
                                    onChange={(e) => handleInputChange("date", e.target.value)}
                                    onClick={(e) => e.target.showPicker?.()}
                                />
                                {formError.date && (
                                    <p className="text-xs text-red-600 mb-2 mt-1">
                                        {formError.date}
                                    </p>
                                )}
                            </div>
                        </div>

                                        {/* Notes */}
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">
                                Notes
                            </label>
                            <div className="w-3/4 pl-2">
                                <textarea
                                    rows={4}
                                    className="pl-3 pt-2 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    value={formData.notes}
                                    placeholder="Notes"
                                    onChange={(e) => handleInputChange("notes", e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </TabContent>
            </Tabs>

            <div className="flex dailog-footer">
                <button
                    className="mr-1.5 whiteBtnShadow btn border border-gray-100 block w-full rounded-lg h-10 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 hover:border-gray-300 focus:bg-white focus:border-gray-300 duration-100 secondary-btn"
                    variant="plain"
                    onClick={handleDialogClose}
                    style={{ backgroundColor: '#FFF4E5' }}
                    disabled={isSubmitting}
                >
                    Cancel
                </button>

                {(tab === "tab1" || tab === "tab2") && (
                    <BtnPrimary
                        onClick={handleNext}
                        className="ml-1.5"
                        style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
                        disabled={isSubmitting}
                    >
                        Next
                    </BtnPrimary>
                )}

                {tab === "tab3" && (
                    <BtnPrimary
                        disabled={isSubmitting}
                        onClick={handleSubmit}
                        className="ml-1.5"
                        style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
                    >
                        {isSubmitting ? (
                            <ThreeDotLoader />
                        ) : (
                            isEdit ? "Update Individual" : "Add Individual"
                        )}
                    </BtnPrimary>
                )}
            </div>
        </Dialog>
    );
};

export default AddEditIndividual;